import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Icons } from 'src/app/models/icons.model';
import { SiteModel } from 'src/app/models/site.model';
import { AdminService } from 'src/app/services/admin.service';
import { CsvService } from 'src/app/services/csv.service';

@Component({
  selector: 'app-admin-inventory',
  standalone: false,
  templateUrl: './admin-inventory.component.html',
  styleUrls: ['./admin-inventory.component.scss']
})
export class AdminInventoryComponent implements OnInit, OnDestroy {
  // Event Handlers
  private adminLoadedEventHandler: Subscription;

  sites: SiteModel[];
  icons = new Icons();

  constructor(public adminService: AdminService, private csvService: CsvService) { }

  ngOnInit(): void {
    if (!this.adminService.isReady) {
      this.adminLoadedEventHandler = this.adminService.adminServiceLoadedEvent.subscribe(
        () => {
          this.loadSiteInventory();
        }
      );
    }
    else {
      this.loadSiteInventory();
    }
  }

  ngOnDestroy() {
    if (this.adminLoadedEventHandler)
      this.adminLoadedEventHandler.unsubscribe();
  }

  // Load Site Inventory
  private async loadSiteInventory() {
    this.sites = await this.adminService.getCameraInventory();
  }

  // Download CSV
  downloadCSV() {
    this.csvService.createAllSitesCameraInventoryCsv(this.sites, `camera-inventory-${new Date().toISOString().split('T')[0]}.csv`);
  }

  // Escape CSV values to handle commas and quotes
  private escapeCSV(value: string): string {
    if (!value) return '';

    const stringValue = value.toString();

    // If value contains comma, quote, or newline, wrap in quotes and escape internal quotes
    if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }

    return stringValue;
  }

}
